"use client";

import { FC, ReactNode } from "react";
import { chakra, Stack, RadioGroup as DSRadioGroup } from "@chakra-ui/react";
import { SkeletonRadioGroup } from "../Skeleton";
import { radioGroupItemText } from "./radio-group.recipe";

export const RadioGroupItemText = chakra(
  DSRadioGroup.ItemText,
  radioGroupItemText,
);

type Option = {
  value: string;
  label: string;
};

type Props = {
  value: string | null;
  options: Option[];
  loading?: boolean;
  disabled?: boolean;
  onChange: (value: string | null) => void;
  renderLabel?: (option: Option) => ReactNode;
};

const RadioGroup: FC<Props> = ({
  value,
  options,
  loading,
  disabled,
  onChange,
  renderLabel = ({ label }) => label,
}) => {
  if (loading) {
    return <SkeletonRadioGroup />;
  }

  return (
    <DSRadioGroup.Root
      value={value}
      disabled={disabled}
      onValueChange={details => onChange(details.value)}
    >
      <Stack direction="column">
        {options.map(option => (
          <DSRadioGroup.Item key={option.value} value={option.value}>
            <DSRadioGroup.ItemHiddenInput />
            <DSRadioGroup.ItemIndicator />
            <RadioGroupItemText>{renderLabel(option)}</RadioGroupItemText>
          </DSRadioGroup.Item>
        ))}
      </Stack>
    </DSRadioGroup.Root>
  );
};

export default RadioGroup;
